'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.normalize = normalize;
exports.recursiveNormalize = recursiveNormalize;
exports.concateQueryParamsToImageUrl = concateQueryParamsToImageUrl;

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// replace URL parameters
function normalize(_uri, params, nocheck) {
  var uri = _uri;
  if (!uri) {
    throw new Error('URI does not specified');
  }
  (0, _keys2.default)(params).forEach(function (key) {
    uri = uri.replace(':' + key, encodeURIComponent(params[key]));
  });
  if (!nocheck && /:/.test(uri)) {
    throw new Error('Required params are remained [' + uri + ']');
  }
  return uri;
}

function recursiveNormalize(source, replace) {
  if (typeof source === 'string') {
    return normalize(source, replace, true);
  }

  var result = {};

  (0, _keys2.default)(source).forEach(function (prop) {
    result[prop] = recursiveNormalize(source[prop], replace);
  });

  return result;
}

function concateQueryParamsToImageUrl(imageUrl, size) {
  var urlObject = _url2.default.parse(imageUrl, true);
  urlObject.query.fit = 'inside|' + size + ':' + size;
  urlObject.query.interpolation = 'lanczos-none';
  delete urlObject.search;
  return _url2.default.format(urlObject);
}


//////////////////
// WEBPACK FOOTER
// ./src/trv-fed-util.js
// module id = 287
// module chunks = 0